import React, { lazy } from 'react';
import RoleGuard from '../../components/auth/RoleGuard';
import AuthGuard from '../../components/auth/AuthGuard';
import ErrorBoundary from '../../components/common/ErrorBoundary';
// Page components are code-split (lazy); <Suspense> lives in AuthenticatedRoutes.jsx.
const InstructorQuizList = lazy(() => import('../../pages/instructor/quizzes/InstructorQuizList'));
const InstructorQuizBuilder = lazy(() => import('../../pages/instructor/quizzes/InstructorQuizBuilder'));
const QuizPreview = lazy(() => import('../../pages/instructor/quizzes/QuizPreview'));
const QuizSubmissions = lazy(() => import('../../pages/instructor/quizzes/QuizSubmissions'));
const InstructorSurveyList = lazy(() => import('../../pages/instructor/surveys/InstructorSurveyList'));
const InstructorSurveyBuilder = lazy(() => import('../../pages/instructor/surveys/InstructorSurveyBuilder'));
const SurveyPreview = lazy(() => import('../../pages/instructor/surveys/SurveyPreview'));
const SurveyResults = lazy(() => import('../../pages/instructor/surveys/SurveyResults'));
const InstructorSubmissionView = lazy(() => import('../../pages/instructor/assignments/InstructorSubmissionView'));
const AssignmentPanel = lazy(() => import('../../pages/instructor/assignments/AssignmentPanel'));
const Gradebook = lazy(() => import('../../pages/instructor/grading/Gradebook'));
const LivePollBoard = lazy(() => import('../../pages/instructor/polls/LivePollBoard'));
const PollList = lazy(() => import('../../pages/instructor/polls/PollList'));
const PollWorkspace = lazy(() => import('../../pages/instructor/polls/PollWorkspace'));

// The /instructor/* routes. Extracted VERBATIM (same order) from
// AuthenticatedRoutes' route table.
const instructorRoutes = [
  { path: '/instructor/polls', element: (
    <AuthGuard>
      <PollList />
    </AuthGuard>
  ) },
  { path: '/instructor/polls/:pollId', element: (
    <AuthGuard>
      <PollWorkspace />
    </AuthGuard>
  ) },
  { path: '/instructor/live-poll', element: (
    <AuthGuard>
      <LivePollBoard />
    </AuthGuard>
  ) },
  { path: '/instructor/quizzes', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <InstructorQuizList />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/new', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorQuizBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/edit', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorQuizBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/preview', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <QuizPreview />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/attempts', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <QuizSubmissions />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/submissions/:attemptId', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <InstructorSubmissionView />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId/assign', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <AssignmentPanel />
    </RoleGuard>
  ) },
  { path: '/instructor/quizzes/:quizId', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <QuizPreview />
    </RoleGuard>
  ) },
  { path: '/instructor/surveys', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <InstructorSurveyList />
    </RoleGuard>
  ) },
  { path: '/instructor/surveys/new', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorSurveyBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/surveys/:surveyId/edit', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <ErrorBoundary>
        <InstructorSurveyBuilder />
      </ErrorBoundary>
    </RoleGuard>
  ) },
  { path: '/instructor/surveys/:surveyId/preview', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <SurveyPreview />
    </RoleGuard>
  ) },
  { path: '/instructor/surveys/:surveyId/results', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <SurveyResults />
    </RoleGuard>
  ) },
  { path: '/instructor/gradebook', element: (
    <RoleGuard allowedRoles={['instructor', 'admin']}>
      <Gradebook />
    </RoleGuard>
  ) },
];

export default instructorRoutes;
